<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import MainLayout from '@/components/layout/MainLayout.vue'
import { useSettingsStore } from '@/stores/settings'

const route = useRoute()
const settingsStore = useSettingsStore()

settingsStore.initTheme()

const showLayout = computed(() => {
  return route.name !== 'Login' && route.path !== '/login'
})
</script>

<template>
  <MainLayout v-if="showLayout" />
  <router-view v-else />
</template>
